import { ApiClientInterface } from './clients';
import { AgentDocument } from './models';

export class AgentDocumentProvider {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async getDocumentUri(): Promise<AgentDocument> {
    return this.apiClient.get('');
  }
}
